import homePageStyles from "./home.module.css";
import Questionnaire from "../../components/questionnaire/questionnaire";
import MyDay from "../../components/myDay/myDay";
import { Category, ISubCategory, SubCategories } from "../../types/types";
import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { homePageContents } from "../../utils/homePageContent";
import { subCategories } from "../../utils/categories";
import ContactUs from "../../components/contactUs/contactUs";
import Modal from "../../components/modals/modal/Modal";
import Cookies_popup from "../../components/modals/cookies_popup/cookies_popup";
import { userSelector } from "../../services/selectors/user.selectors";
import { useAppSelector } from "../../services/hooks";
import { testUserEmail, testUserEmail2 } from "../../utils/constants";
import i18n from "../../i18n";
import { tWithKeyAttr as t } from "../../i18nHelper";

interface IHomePageProps {
  activeCategory: Category;
  setCategory: Dispatch<SetStateAction<ISubCategory>>;
}
function HomePage({
  activeCategory = Category.Day,
  setCategory,
}: // setTreatmentCategory,
IHomePageProps): JSX.Element {
  const [showCookiesPopup, setShowCookiesPopup] = useState(false);
  const user = useAppSelector(userSelector);

  const isTestUser =
    user?.email?.toLowerCase() === testUserEmail ||
    user?.email?.toLowerCase() === testUserEmail2;

  const isProduction = true;
    // typeof process !== "undefined" &&
    // (process as any)?.env?.NODE_ENV === "production" &&
    // !window.location.hostname.includes("test") &&
    // !window.location.hostname.includes("local");

  useEffect(() => {
    let cookiesTimeout: number | undefined;
    let pop_status = localStorage.getItem("pop_status");
    if (!pop_status) {
      cookiesTimeout = window.setTimeout(() => setShowCookiesPopup(true), 5000);
      localStorage.setItem("pop_status", "true");
    }
    return () => {
      window.clearTimeout(cookiesTimeout);
    };
  }, []);
  const content = useMemo(
    () => homePageContents.find((c) => c.value === activeCategory),
    [activeCategory]
  );
  const sortedSections = useMemo(() => {
    return content?.sections
      ? [...content.sections].sort(
          (a, b) => (b.disabled ? 0 : 1) - (a.disabled ? 0 : 1)
        )
      : [];
  }, [content]);
  return (
    <section dir={i18n.dir()} className={homePageStyles.section}>
      {showCookiesPopup && (
        <Modal onClose={() => setShowCookiesPopup(false)}>
          <Cookies_popup onClose={() => setShowCookiesPopup(false)} />
        </Modal>
      )}
      <Questionnaire />
      {activeCategory === Category.Day ? (
        <MyDay />
      ) : activeCategory === Category.Contacts ? (
        <ContactUs />
      ) : (
        <div className={homePageStyles.section}>
          <h3 className={homePageStyles.section__title}>{t(content?.title)}</h3>
          <ul className={homePageStyles.section__categories}>
            {sortedSections
              ?.sort((a, b) => (b.disabled ? 0 : 1) - (a.disabled ? 0 : 1))
              .map((s, index) => (
                <li key={index}>
                  <Link
                    to={!s.disabled || (isTestUser && !isProduction) ? s.navigateTo : "#"}
                    state={s?.state}
                    className={`${homePageStyles.section__category} ${
                      s.disabled &&
                      (!isTestUser || isProduction) &&
                      homePageStyles.section__disabled
                    } hover`}
                    onClick={() => {
                      const categoryKey = s.value as SubCategories;
                      if (
                        (!s.disabled || (isTestUser && !isProduction)) &&
                        subCategories.hasOwnProperty(categoryKey)
                      ) {
                        setCategory(subCategories[categoryKey] as ISubCategory);
                      }
                    }}
                  >
                    <div className={homePageStyles.section__sectionName}>
                      <img
                        src={s.icon}
                        className={`${homePageStyles.section__icon}`}
                        alt={t(s.text)}
                      />
                      <p className={homePageStyles.section__text}>{t(s.text)}</p>
                    </div>
                    <button
                      type="button"
                      className={`${homePageStyles.section__sectionArrowBtn} btn`}
                    />
                  </Link>
                </li>
              ))}
          </ul>
        </div>
      )}
    </section>
  );
}

export default HomePage;
